import styled from 'styled-components';

export const CarbonLogoStyle = styled.div`
    img{
        width: 204px;
        height:33px;
    }
`;